export const getCartData="getCartData"
export const getDetailsPageData="getDetailsPageData"